import { object } from 'valibot'

import { stringToNumber } from '@/libs/valibot'

export const TaxCategoryParamsSchema = object({
  taxCategoryId: stringToNumber()
})
